import React, {useEffect} from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import get from 'lodash/get'
import PropTypes from "prop-types";
import {Box} from "@material-ui/core";

const style={
    rightButton:{
        backgroundColor:"#2e5790",
        color:"#ffffff",
        width:"100px",
        textTransform:"none",
        fontSize:"14px"
    },
    leftButton:{
        backgroundColor:" #ffffff",
        color: "#2e5790",
        border: "1px solid #2e5790",
        width:"100px",
        textTransform:"none",
        fontSize:"14px"

    }
}

function AppDialog(props){
    const isOpen = get(props,"isOpen")
    const title = get(props,"title")
    const text = get(props,"text")
    const rightButtonText = get(props,'rightButtonText',"Ok")
    const isTwoButtons = get(props,"isTwoButtons",false)
    const leftButtonText = get(props,"leftButtonText","Cancel")
    useEffect(()=>{
        props.callback();
    },[])
return (

    <Dialog
        open={isOpen}
        // onClose={props.requestCloseHandler}
        maxWidth={"xs"}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <DialogContentText
                id="alert-dialog-description"
                style={{ whiteSpace: "pre-wrap" }}
            >
                {text}
            </DialogContentText>
        </DialogContent>
        <DialogActions style={isTwoButtons?{display:"flex",justifyItems:"center",paddingBottom:"20px"}:null}>
            {isTwoButtons?
                <Button  color="primary" onClick={props.requestCloseHandler} style={style.leftButton}>
                {leftButtonText}
            </Button>:null}
            <Box paddingRight={"20px"}/>
            <Button  onClick={props.requestActionHandler} color="primary" style={style.rightButton}>
                {rightButtonText}
            </Button>
        </DialogActions>
    </Dialog>
)
}

AppDialog.propTypes = {
    requestCloseHandler:PropTypes.func.isRequired,
    requestActionHandler:PropTypes.func,
    title:PropTypes.string.isRequired,
    text:PropTypes.string.isRequired,
    isOpen:PropTypes.bool.isRequired,
    callback:PropTypes.func
}
AppDialog.defaultProps = {
    requestCloseHandler:function(){},
    title:"",
    text:"",
    isOpen:false,
}

export default AppDialog
